import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import TextInput from "../ui/textInput";
import {updateQuote} from "../../actions/roomsFunctions";


const ShoppingCartRoomMultiplierInput = (props) => {

  const {quotes, quoteIndex, updateQuote, className, fabricatorData} = props;
  const fabricatorSettings = fabricatorData.settings;

  const quote = quotes[quoteIndex];
  const showPrice = fabricatorSettings.showPricing && !fabricatorData.hidePricesFromUser;

  if (!quote || !showPrice) {
    return null; // just in case
  }

  // if (selectionFeatureInfo && selectionFeatureInfo.dbFeature.id && document.kvConfig.isBackend) {
  //   return <FeatureInfoPriceInput/>
  // }

  const handlePriceOnChange = (newAmount) => {
    quote.roomMultiplier = +newAmount;
    updateQuote(quote);
    // updateFeatureInfoCount();
  }

  return (
    <div className={"product-info__edit " + (className ? " " + className : "")}>
      <TextInput className={"price-input w-4 ml-0"}
                 numberInput={true}
                 currencySing={true}
                 autoComplete={"off"}
                 onChange={handlePriceOnChange}
                 onRealChange={handlePriceOnChange}
                 value={"x" + (quote.roomMultiplier || 1)}/>
    </div>
  )
};

ShoppingCartRoomMultiplierInput.propTypes = {
  quoteIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onBlur: PropTypes.func,
  className: PropTypes.string,
};

const mapStateToProps = (store) => {
  const {quotes} = store.quotesState;

  return {
    quotes,
    featureInfoCount: store.selectionState.featureInfoCount,
    fabricatorData: store.fabricatorState,
  };
};

const mapDispatchToProps = {
  updateQuote,
  // updateFeatureInfoCount
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ShoppingCartRoomMultiplierInput)
);
